import React, { forwardRef } from 'react';

const Input = forwardRef(function Input(
  { label, error, type = 'text', className = '', ...props },
  ref
) {
  return (
    <div className="flex flex-col">
      {label && <label className="input-label">{label}</label>}
      <input
        ref={ref}
        type={type}
        className={`input-field ${error ? 'border-red-400' : ''} ${className}`}
        {...props}
      />
      {error && (
        <p className="text-xs mt-0.5" style={{ color: '#fca5a5' }}>{error}</p>
      )}
    </div>
  );
});

export default Input;
